<!-- MODAL verDeposito -->
<div mdbModal #verDeposito="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <div class="modal-dialog modal-fluid" style="max-width: 70%;" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title w-100 text-left" id="myModalLabel">
                    Detalle del Deposito {{deposito?.codigo}}
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="verDeposito.hide()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <!-- <div class="col mb-1" style="display: flex; justify-content: flex-end;">
            <div class="leyenda">
              <mdb-icon fas icon="circle" class="text-success"></mdb-icon><span> Atendido</span>
            </div>
            <div class="leyenda">
              <mdb-icon fas icon="circle" class="text-danger"></mdb-icon><span> No atendido</span>
            </div>
            <div class="leyenda">
              <mdb-icon fas icon="circle" class="text-warning"></mdb-icon><span> Cambiado</span>
            </div>
          </div> -->
                </div>
                <mdb-spinner spinnerColor="blue" *ngIf="loading"></mdb-spinner>

                <div class="table-responsive" *ngIf="listaDepositos">

                    <app-no-data-alert *ngIf="listaDepositos?.length === 0">
                    </app-no-data-alert>

                    <table class="table table-striped table-hover table-sm align-middle"
                        *ngIf="listaDepositos?.length > 0">
                        <thead class="grey lighten-2">
                            <tr>
                                <th scope="col">Nro. Doc</th>
                                <th scope="col" class="text-center">Fec.Ingreso</th>
                                <th scope="col" class="text-center">Fec. Vcto.</th>
                                <th scope="col" >Banco</th>
                                <th scope="col" >Rut</th>
                                <th scope="col" >Cliente</th>
                                <th scope="col" class="text-right">Monto</th>
                                <th scope="col" class="text-center">Estado</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let deposito of listaDepositos">
                                <td >{{deposito.numero_doc}}</td>
                                <td class="text-center">{{deposito.fecha_ingreso | fecha}}</td>
                                <td class="text-center">{{deposito.fecha_vecimiento | fecha}}</td>
                                <td >{{deposito.banco_nombre_origen}}</td>
                                <td >{{deposito.clienteRutFormato | rut}}</td>
                                <td >{{deposito.cliente_proveedor_nombre}}</td>
                                <td class="text-right">{{deposito.monto | numerico}}</td>
                                <td class="text-center">
                                    <mdb-badge pill="true" *ngIf="deposito.estado === 1" warning="true">{{deposito.estado_nombre}}
                                    </mdb-badge>
                                    <mdb-badge pill="true" *ngIf="deposito.estado === 2" success="true">{{deposito.estado_nombre}}
                                    </mdb-badge>
                                    <mdb-badge pill="true" *ngIf="deposito.estado === 3" danger="true" >{{deposito.estado_nombre}}
                                    </mdb-badge><!-- protestado | rojo -->
                                    <mdb-badge pill="true" *ngIf="deposito.estado === 8" danger="true" >{{deposito.estado_nombre}}
                                    </mdb-badge><!-- protestado | rojo -->
                                    <mdb-badge pill="true" *ngIf="deposito.estado === 9" danger="true" >{{deposito.estado_nombre}}
                                    </mdb-badge><!-- protestado | rojo -->
                                    <mdb-badge pill="true" *ngIf="deposito.estado === 4" info="true">{{deposito.estado_nombre}}
                                    </mdb-badge>
                                    <mdb-badge pill="true" *ngIf="deposito.estado === 5" primary="true" >{{deposito.estado_nombre}}
                                    </mdb-badge><!-- redeposito | morado -->
                                    <mdb-badge pill="true" *ngIf="deposito.estado === 7" success="true" >{{deposito.estado_nombre}}
                                    </mdb-badge><!-- redeposito | morado -->
                                </td>
                            </tr>
                        </tbody>
                        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
                            *ngIf="listaDepositos?.length > 0"></app-pagination>
                    </table>
                </div>
            </div>
            <div class="modal-footer justify-content-between">
                <button size="sm" class="btn btn-sm" type="button" class="btn btn-default waves-light" data-dismiss="modal"
                    (click)="verDeposito.hide()" mdbWavesEffect>
                    Cerrar
                </button>
            </div>
        </div>
    </div>
</div>